import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-widget-chip',
  imports: [CommonModule],
  template: `
    <small>
      <ng-content></ng-content>
    </small>
  `,
  styleUrls: ['./widget-chip.component.scss'],
})
export class WidgetChipComponent {}
